import { render, staticRenderFns } from "./CardStudentInfo.vue?vue&type=template&id=7424d448&scoped=true&"
import script from "./CardStudentInfo.vue?vue&type=script&lang=js&"
export * from "./CardStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardStudentInfo.vue?vue&type=style&index=0&id=7424d448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7424d448",
  null
  
)

export default component.exports